import { render, staticRenderFns } from "./EventsOnADayCard.vue?vue&type=template&id=f4a6334e"
import script from "./EventsOnADayCard.vue?vue&type=script&lang=js"
export * from "./EventsOnADayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports